import React from 'react'
import { Skeleton } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { BaseModalV2, CloseButton } from 'components/ui'
import CommentsContentLoader from 'components/Comments/CommentsContentLoader'
import { isRtlSelector } from 'redux/selectors/general'
import useLocaleText from 'components/useLocaleText'
import { reviewLiterals } from './literals'
import styles from './styles.module.css'

/** The same dual-view footprint while opening a task or changing its result context. */
export function ExecutionSkeleton({ media = false }: { media?: boolean }) {
  const rtl = useSelector(isRtlSelector)
  const t = useLocaleText(reviewLiterals)
  return (
    <div
      className={`${styles.skeleton} ${media ? styles.mediaSkeleton : ''}`}
      dir={rtl ? 'rtl' : 'ltr'}
      role="status"
      aria-label={t.loading}
      aria-busy="true"
    >
      <section className={styles.skeletonPanel} aria-hidden="true">
        <Skeleton height="16px" width="45%" mb="20px" />
        {media ? (
          <Skeleton flex="1" minH="180px" borderRadius="12px" />
        ) : (
          [0, 1, 2].map((index) => (
            <div className={styles.skeletonRow} key={index}>
              <Skeleton height="48px" width="48px" borderRadius="10px" flexShrink={0} />
              <div>
                <Skeleton height="14px" width="65%" mb="10px" />
                <Skeleton height="10px" width="40%" />
              </div>
            </div>
          ))
        )}
      </section>
      <section className={styles.skeletonPanel} aria-hidden="true">
        {media ? (
          <>
            <CommentsContentLoader count={3} />
            <Skeleton height="96px" mt="auto" borderRadius="16px" />
          </>
        ) : (
          <>
            <Skeleton height="18px" width="35%" mb="24px" />
            <Skeleton flex="1" minH="180px" borderRadius="12px" />
            <Skeleton height="36px" width="140px" mt="24px" mx="auto" />
          </>
        )}
      </section>
    </div>
  )
}

export function ExecutionModalSkeleton({ onClose, media }: { onClose: () => void; media: boolean }) {
  return (
    <BaseModalV2
      floating
      isOpen
      onClose={onClose}
      modalContentProps={{ maxW: 'none', minW: 0, className: 'floating-media-modal task-execution-modal' }}
      modalHeaderProps={{ px: 0, py: '2px' }}
      modalBodyProps={{ maxH: 'none', height: '100%', flex: 1, minH: 0, overflow: 'hidden', px: 0, py: 0 }}
      header={
        <div className={styles.skeletonHeader}>
          <Skeleton height="18px" width="220px" />
          <CloseButton onClick={onClose} />
        </div>
      }
      body={<ExecutionSkeleton media={media} />}
      footer={<></>}
    />
  )
}
